import { action, Action } from 'easy-peasy';

export interface ICustomParams {
    logo?: string;
    hideFilter?: boolean;
    hideMask?: boolean;
    hideMenus?: string[];
    hideMattingVip?: boolean;
    hideTextMenuContent?: boolean;
    hideTextMask?: boolean;
    hideAiText?: boolean;
    hideFeaturedPhotos?: boolean;
    hideFeedback?: boolean;
    feedbackText?: string;
    saveBtnText?: string;
    showSaveLocal?: boolean;
    defaultCollapse?: string;
    hideTextEffect?: boolean;
    textEffectFree?: boolean;
    mattingFree?: boolean;
    hideFolder?: boolean;
    hideAiRemoveVip?: boolean;
    removeFree?: boolean;
    showTemplateFilter?: boolean;
    hideTemplateCategory?: boolean;
    customSearch?: boolean;
    hideCreateCopy?: boolean;
    hideSizeVip?: boolean;
    hideSizeBack?: boolean;
    appBucket?: string;
    hideSizeExtension?: boolean;
    hideBackgroundLibrary?: boolean;
    hideAiEntrance?: boolean;
    [key: string]: any;
}

export interface ISdkModel {
    domainWhiteList: string[];
    setDomainWhiteList: Action<ISdkModel, string[]>;
    isInSDK: boolean;
    setIsInSDK: Action<ISdkModel, boolean>;
    customParams: ICustomParams;
    setCustomParams: Action<ISdkModel, ICustomParams>;
}

export const sdkModel: ISdkModel = {
    domainWhiteList: [],
    setDomainWhiteList: action((state, type) => {
        state.domainWhiteList = type;
    }),
    isInSDK: false,
    setIsInSDK: action((state, isInSDK) => {
        state.isInSDK = isInSDK;
    }),
    customParams: {},
    setCustomParams: action((state, customParams) => {
        state.customParams = customParams;
    }),
};
